// marketplace experimentation keys
export const MARKETPLACE_STORE_HEADER_EXPERIMENTATION_KEY = "marketplace-store-header-funnel-experiment"
export const MARKETPLACE_SHORTEN_COLLECTIONS_PAGE_EXPERIMENTATION_KEY = "marketplace-shorten-collections-page-funnel-experiment"
export const MARKETPLACE_SUGGESTED_ITEMS_EXPERIMENTATION_KEY = "marketplace-suggested-item-feature-experiment"
export const MARKETPLACE_NEW_SEARCH_ENGINE_EXPERIMENTATION_KEY = "marketplace-new-search-engine-feature-experiment"

// togglebank experimentation keys  
export const TOGGLEBANK_CHATBOT_AI_EXPERIMENTATION_KEY = "ai-config-experiment"
export const TOGGLEBANK_SIGNUP_FUNNEL_EXPERIMENTATION_KEY = "togglebank-signup-funnel-experiment"
export const TOGGLEBANK_SPECIAL_OFFERS_EXPERIMENTATION_KEY = "togglebank-special-offers-feature-experiment"

// togglebank signup funnel metrics
export const SIGN_UP_STARTED = "signup-started"
export const INITIAL_SIGN_UP_COMPLETED = "initial-signup-completed"
export const SIGN_UP_PERSONAL_DETAIL_COMPLETED = "signup-personal-details-completed"
export const SIGN_UP_SERVICES_COMPLETED = "signup-services-completed"
export const SIGN_UP_FLOW_COMPLETED = "signup-flow-completed"



// togglebank widget position experimentation
export const TOGGLEBANK_WIDGET_POSITION_EXPERIMENTATION_KEY = "togglebank-widget-position-feature-experiment"